export const AggrementPdfFile = {
    "101internet": {
        app1:
            "https://dbe5e261-9123-4594-a177-5db8e7d8f6fb.selcdn.net/docs/agreement/101_app_1.pdf",
        app2:
            "https://dbe5e261-9123-4594-a177-5db8e7d8f6fb.selcdn.net/docs/agreement/101_app_2.pdf",
        processing:
            "https://dbe5e261-9123-4594-a177-5db8e7d8f6fb.selcdn.net/docs/agreement/101_agreement.pdf",
        manual:
            "https://dbe5e261-9123-4594-a177-5db8e7d8f6fb.selcdn.net/docs/agreement/manual.pdf",
        functional:
            "https://dbe5e261-9123-4594-a177-5db8e7d8f6fb.selcdn.net/docs/agreement/functional_description.pdf",
    },
    moskvaonline: {
        app1:
            "https://dbe5e261-9123-4594-a177-5db8e7d8f6fb.selcdn.net/docs/agreement/mol_app_1.pdf",
        app2:
            "https://dbe5e261-9123-4594-a177-5db8e7d8f6fb.selcdn.net/docs/agreement/mol_app_2.pdf",
        processing:
            "https://dbe5e261-9123-4594-a177-5db8e7d8f6fb.selcdn.net/docs/agreement/mol_agreement.pdf",
    },
    piteronline: {
        app1:
            "https://dbe5e261-9123-4594-a177-5db8e7d8f6fb.selcdn.net/docs/agreement/pol_app_1.pdf",
        app2:
            "https://dbe5e261-9123-4594-a177-5db8e7d8f6fb.selcdn.net/docs/agreement/pol_app_2.pdf",
        processing:
            "https://dbe5e261-9123-4594-a177-5db8e7d8f6fb.selcdn.net/docs/agreement/pol_agreement.pdf",
    },
};

export const supportCat =
    "https://dbe5e261-9123-4594-a177-5db8e7d8f6fb.selcdn.net/images/cat_icons/cat_headset.png";
